import { createSelector } from 'utils/app.util';

export const getIntegrityManagementUsersFromState = createSelector(
  (state) =>
    state.getIn([
      'entity',
      'integrityWellOverview',
      'integrityManagementUsers',
    ]),
  (users) => users,
);

export const getActivityLogsFromState = createSelector(
  (state) => state.getIn(['entity', 'integrityWellOverview', 'activityLogs']),
  (activityLogs) => activityLogs,
);

export const getFieldActivityLogsFromState = createSelector(
  (state) =>
    state.getIn(['entity', 'integrityWellOverview', 'fieldActivityLogs']),
  (activityLogs) => activityLogs,
);
